let isLoading = false;

async function getNextPage(nextUrl) {
  try {
    let res = await fetch(nextUrl);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  let nextUrl = document.getElementById('paginateNext').getAttribute('href');
  if(nextUrl === '') {
    return
  }
  isLoading = true;

  let load_more_spinner = document.getElementById('icon_loading');
  load_more_spinner.classList.remove('hidden')
  let nextPage = await getNextPage(nextUrl);

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  let productgrid = nextPageDoc.getElementById('product-grid');
  let new_products = productgrid.querySelectorAll('.grid__item');
  let newUrl = nextPageDoc.getElementById('paginateNext');
  let products_on_page = document.getElementById('product-grid');
  new_products.forEach(item => {
    products_on_page.appendChild(item);
  })

  if(newUrl) {
    document.getElementById('paginateNext').setAttribute('href', newUrl.getAttribute('href'))
  } else {
    document.getElementById('paginateNext').setAttribute('href', '')
  }
  load_more_spinner.classList.add('hidden')
  isLoading = false;
}
document.addEventListener('scroll', async function() {
  let load_more_spinner = document.getElementById('load_more_spinner');
  if (isInView(load_more_spinner) && !isLoading) {
    await loadMoreProducts();
  }
});

function isInView(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    (rect.bottom - 300) <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

